import { CloudAccountType } from '@repo/api-gw-sdk';
import type { Account } from '@repo/api-gw-sdk';

import { useDAL } from '@/contexts/useDAL';

export const useUpdateAccount = (
  onUpdated: (accountId: string) => void,
  setValidationInProgress: (validationInProgress: boolean) => void,
  setHasError: (hasError: boolean) => void,
  account: Account | undefined,
  expectVersionUpdate = true
) => {
  const dal = useDAL();

  const updateAccount = async () => {
    if (!account) {
      return;
    }

    try {
      setValidationInProgress(true);

      const previousInstalledVersion = account.installedVersion;

      const updatedAccount =
        account.accountType === CloudAccountType.Source
          ? await dal.cloudAccounts.source.syncPermissions(account.id)
          : account.accountType === CloudAccountType.Restore
            ? await dal.cloudAccounts.restore.syncPermissions(account.id)
            : undefined;

      const newInstalledVersion = updatedAccount?.installedVersion;

      if (
        expectVersionUpdate &&
        previousInstalledVersion === newInstalledVersion
      ) {
        setHasError(true);
      } else {
        onUpdated(account.id);
      }
    } catch {
      setHasError(true);
    } finally {
      setValidationInProgress(false);
    }
  };

  return {
    updateAccount,
  };
};
